var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.display_image_dialog),callback:function ($$v) {_vm.display_image_dialog=$$v},expression:"display_image_dialog"}},[_c('v-img',{attrs:{"contain":"","src":_vm.image_src,"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }